import * as monaco from 'monaco-editor';
import {
  CodeActionRequest,
  CodeActionResolveRequest,
  Command,
  ProtocolConnection,
  ServerCapabilities,
} from 'vscode-languageserver-protocol';

import {
  OnException,
  codeActionContextMapping,
  codeActionMapping,
  commandMapping,
  rangeMapping,
} from '../utils/convertVscodeToMonaco';

export function codeActionProvider(
  languageId: string,
  connection: ProtocolConnection,
  codeActionOptions: ServerCapabilities['codeActionProvider'],
  onException: OnException,
) {
  if (codeActionOptions === undefined || codeActionOptions === false) {
    return;
  }

  const {
    codeActionKinds,
    resolveProvider,
    // TODO: do we want to do anything with these?
    // workDoneProgress,
  } =
    codeActionOptions === true
      ? { codeActionKinds: undefined, resolveProvider: undefined }
      : codeActionOptions;

  monaco.languages.registerCodeActionProvider(
    languageId,
    {
      async provideCodeActions(
        model,
        range,
        context,
        token,
      ): Promise<monaco.languages.CodeActionList | undefined | null> {
        const actions = await connection.sendRequest(
          CodeActionRequest.type,
          {
            context: codeActionContextMapping.monacoToVscode(
              context,
              onException,
            ),
            range: rangeMapping.monacoToVscode(range),
            textDocument: { uri: model.uri.toString(true) },
            // partialResultToken,
            // workDoneToken,
          },
          token,
        );
        if (token.isCancellationRequested || !actions) {
          return null;
        }

        return {
          dispose: () => {},
          actions: actions.map((action) => {
            if (Command.is(action)) {
              return commandMapping.vscodeToMonaco(action);
            } else {
              return codeActionMapping.vscodeToMonaco(action, onException);
            }
          }),
        };
      },
      resolveCodeAction: resolveProvider
        ? async (
            codeAction: monaco.languages.CodeAction,
            token: monaco.CancellationToken,
          ) => {
            const resolvedAction = await connection.sendRequest(
              CodeActionResolveRequest.type,
              codeActionMapping.monacoToVscode(codeAction, onException),
              token,
            );
            return codeActionMapping.vscodeToMonaco(
              resolvedAction,
              onException,
            );
          }
        : undefined,
    },
    {
      providedCodeActionKinds: codeActionKinds,
      // documentation
    },
  );
}
